<app-slider></app-slider>
<app-home-service></app-home-service>
<app-home-contact-us></app-home-contact-us>